// extracted by mini-css-extract-plugin
export var dots = "e_W_cx";
export var layoutContainerOverride = "e_W_cv";
export var screenTablet = "768px";
export var sectionContainer = "e_W_9";
export var statisticContainer = "e_W_cw";
export var statisticWrapper = "e_W_cy";